"use strict";

window.site = window.site || {};

/**
 * Header - Side Navigation - Scripts
 * @class Site
 * @static
 */
site.Search = function Search($) {
  'use strict';

  /**
   * jQuery elements
   * @private
   */

  // Your globale varaibles here

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function init() {
    // Abort if already initialized
    if (inited) {
      return false;
    }
    inited = true;
    $('.toolbar-search-btn label').click(function () {
      $('.toolbar-search-btn').toggleClass('active');
    });
    return true;
  };

  // Expose public methods & properties
  return {
    init: init
  };
}(jQuery);